import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography } from '@mui/material';
import { DynamicIcon } from '@pihealth/common-ui-library';
import * as React from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import staticData from '../../../resources/static.json';
import { setShowCMPArr } from 'src/store/feasibility';
import DJ2Form from 'src/components/Conduct/ToolkitForms/configurableformprovider';
import { useEffect, useRef, useState } from 'react';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setMessage } from 'src/store/Message';
import { useFeasibilityForms } from './useFeasibilityForm';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { hideLoader, showLoader } from 'src/store/Loader';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useFieldTranslation } from '../../fields/useFieldTranslation';

const FeasibilityForm: React.FunctionComponent<any> = () => {
  const selectedStudy: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [formJsonData, setFormJsonData] = useState<any>(null);
  const [isFieldChanged, setisFieldChanged] = useState(false);
  const [defaultValues, setDefaultValues] = useState(null as any);
  const [changedData, SetchangedData] = useState<any>({});
  const [rules, setRules] = useState<any>(null as any);
  const tempField = 1;
  const [isUpdate, SetIsUpdate] = useState<any>(false);
  const [currentDataEntryFormId, SetcurrentDataEntryFormId] = useState<any>(null);
  const formRef: any = useRef(null);
  const selectedformData: any = useAppSelector(state => state.feasibility.selectedformData);
  const user = useAppSelector(state => `${state.user.user?.firstName} ${state.user.user?.lastName}`);
  const { checkPermission } = usePermissionWrapper();
  const { unSavedWarning } = useFieldTranslation();
  const FeasibilityPermission = checkPermission('update_tsda_feasibility');
  const { selectedAppSection } = useSelectedAppInfo();
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const dispatch = useAppDispatch();
  const {
    createFeasibilityFromDataFunc,
    createFeasibilityFromDataIsError,
    createFeasibilityFromDataIsSuccess,
    createFeasibilityFromDataIsLoading,
    createFeasibilityFromDataError,
    selectFeasibilityFromDataFunc,
    selectFeasibilityFromData,
    selectFeasibilityFromDataIsError,
    selectFeasibilityFromDataIsSuccess,
    selectFeasibilityFromDataIsLoading,
    updateFeasibilityFormDataFunc,
    updateFeasibilityFormDataIsError,
    updateFeasibilityFormDataIsSuccess,
    updateFeasibilityFormDataIsLoading,
    updateFeasibilityFormDataError,
    getFormLibrary,
    getFormLoading,
    formData
  } = useFeasibilityForms();

  useEffect(() => {
    getFormLibrary({
      OID: selectedformData.form_oid,
      published_version: selectedformData.feasibility_form_version,
      study_id: selectedStudy,
      country: selectedCountry,
      site_id: selectedSite,
      application: process.env.REACT_APP_NAME,
      application_section: selectedAppSection,
      application_module_section: selectedAppSection
    });
  }, []);

  const getAndShowToolkitFormData = async () => {
    const reqPayload = {
      OID: selectedformData.form_oid,
      feasibility_form_version: selectedformData.feasibility_form_version
    };
    await selectFeasibilityFromDataFunc({
      data: reqPayload,
      study_id: selectedStudy,
      site_id: selectedSite,
      country: selectedCountry
    });
  };

  useEffect(() => {
    if (formData) {
      getAndShowToolkitFormData();
    }
  }, [formData]);

  const handelBackButton = () => {
    if (!isFieldChanged) {
      dispatch(setShowCMPArr('feasibilityTable'));
    } else {
      setOpenConfirmExit(true);
    }
  };

  const bindDefaultValuesToForm = (clonedObj: any) => {
    const reClonedObj = JSON.parse(JSON.stringify(clonedObj));
    reClonedObj.sections.map((section: any) => {
      section.rows.map((row: any) => {
        row.fields.map((field: any) => {
          field.isCustomForm = true;
          if (field.cmp == 'checkbox' && field?.default_value && field?.default_value.length > 0) {
            let values = {};
            field?.default_value.map((val: any) => {
              values = { ...values, [val]: true };
            });
          } else if (
            field?.cmp == 'select' &&
            field?.default_value &&
            field?.data_dictionary_values &&
            field?.data_dictionary_values.length > 0
          ) {
            if (field?.multiple) {
              const values = [];
              for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                if (field?.default_value.includes(field?.data_dictionary_values[i].value)) {
                  values.push({
                    label: field?.data_dictionary_values[i].code_list_value,
                    value: field?.data_dictionary_values[i].value
                  });
                }
              }
              field.default_value = values;
            } else {
              let values = {};
              for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                if (field?.data_dictionary_values[i].value == field?.default_value) {
                  values = {
                    label: field?.data_dictionary_values[i].code_list_value,
                    value: field?.data_dictionary_values[i].value
                  };
                  break;
                }
              }
              field.default_value = values;
            }
          }
        });
      });
    });
    setFormJsonData(reClonedObj);
  };

  useEffect(() => {
    if (selectFeasibilityFromData && selectFeasibilityFromDataIsSuccess && formData) {
      const clonedObj: any = JSON.parse(JSON.stringify(formData?.meta));
      if (selectFeasibilityFromData?.result.length > 0) {
        let savedData: any = {};
        clonedObj.sections.map((section: any) => {
          section.rows.map((row: any) => {
            row.fields.map((field: any) => {
              const values = selectFeasibilityFromData?.result[0][field?.key];
              if (field.cmp == 'checkbox' && values && Object.keys(values).length > 0) {
                const valArr: any = [];
                Object.keys(values).map((valkey: any) => {
                  if (values[valkey] !== false) {
                    valArr.push(valkey);
                  }
                });
                field.default_value = valArr;
                savedData = { ...savedData, [field?.key]: values };
              } else if (field.cmp == 'select' && values && Object.keys(values).length > 0) {
                if (field?.multiple) {
                  const multiselectVal = values?.key;
                  const valArr: any = [];
                  multiselectVal.map((valkey: any) => {
                    valArr.push(valkey?.code_list_value_code || valkey?.value);
                  });
                  field.default_value = valArr;
                  savedData = { ...savedData, [field?.key]: multiselectVal };
                } else {
                  field.default_value = values;
                  savedData = { ...savedData, [field?.key]: values };
                }
              } else {
                field.default_value = selectFeasibilityFromData?.result[0][field?.key];
                savedData = { ...savedData, [field?.key]: selectFeasibilityFromData?.result[0][field?.key] };
              }

              SetcurrentDataEntryFormId(selectFeasibilityFromData?.result[0]?.id);
            });
          });
        });
        SetchangedData({ ...savedData });
        setFormJsonData(clonedObj);
        SetIsUpdate(true);
      } else {
        bindDefaultValuesToForm(clonedObj);
      }
    }
  }, [selectFeasibilityFromData, selectFeasibilityFromDataIsSuccess]);

  useEffect(() => {
    if (selectFeasibilityFromDataIsError && !selectFeasibilityFromDataIsLoading && formData) {
      bindDefaultValuesToForm(formData?.meta);
    }
  }, [selectFeasibilityFromDataIsError, selectFeasibilityFromDataIsLoading]);

  useEffect(() => {
    if (formJsonData?.sections) {
      const formData = formJsonData.sections.flatMap((section: any) => section.rows.flatMap((row: any) => row.fields));
      const initValues = formData.reduce(
        (acc: any, cur: any) => ({ ...acc, [cur.key]: cur.default_value || null }),
        {}
      );
      if (selectFeasibilityFromData?.result[0]?.file_data) {
        setDefaultValues({
          ...initValues,
          file_data: selectFeasibilityFromData?.result[0].file_data,
          event_uuid: selectFeasibilityFromData?.result[0].event_uuid
        });
      } else {
        setDefaultValues({ ...initValues, file_data: [], event_uuid: null });
      }

      let mockRulesObj: any = {};
      formData.map((item: any) => {
        if (item?.required) {
          const makeObj = {
            required: {
              value: true,
              errorText: 'Required'
            }
          };
          mockRulesObj = { ...mockRulesObj, [item.key]: makeObj };
        }
        if (item?.cmp == 'date' && !item.allow_partial) {
          mockRulesObj = {
            ...mockRulesObj,
            [item.key]: { ...mockRulesObj?.[item.key], date: { value: true, errorText: 'Invalid Data' } }
          };
        }
      });
      setRules(mockRulesObj);
    }
  }, [formJsonData, selectFeasibilityFromData]);

  useEffect(() => {
    if (
      updateFeasibilityFormDataIsLoading ||
      selectFeasibilityFromDataIsLoading ||
      createFeasibilityFromDataIsLoading ||
      getFormLoading
    ) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [
    updateFeasibilityFormDataIsLoading,
    selectFeasibilityFromDataIsLoading,
    createFeasibilityFromDataIsLoading,
    getFormLoading
  ]);

  useEffect(() => {
    if (
      (!createFeasibilityFromDataIsLoading && createFeasibilityFromDataIsError) ||
      (!updateFeasibilityFormDataIsLoading && updateFeasibilityFormDataIsError)
    ) {
      const errorData: any = createFeasibilityFromDataError || updateFeasibilityFormDataError;
      if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: errorData?.data?.context.message,
            severity: 'error'
          })
        );
      }
    }
    if (
      (!createFeasibilityFromDataIsLoading && createFeasibilityFromDataIsSuccess) ||
      (!updateFeasibilityFormDataIsLoading && updateFeasibilityFormDataIsSuccess)
    ) {
      dispatch(
        setMessage({
          msgDetails: 'Feasibility questionnaire is updated successfully',
          severity: 'success'
        })
      );
      getAndShowToolkitFormData();
    }
  }, [
    createFeasibilityFromDataIsLoading,
    createFeasibilityFromDataError,
    createFeasibilityFromDataIsError,
    createFeasibilityFromDataIsSuccess,
    updateFeasibilityFormDataIsSuccess,
    updateFeasibilityFormDataIsError,
    updateFeasibilityFormDataError
  ]);

  const onDJ2Change = (data: any, fieldConfig: any) => {
    if (fieldConfig.error) {
      for (const section of formJsonData.sections) {
        for (const row of section.rows) {
          for (const field of row.fields) {
            if (fieldConfig.key === field.key) {
              field.helperText = '';
              field.error = false;
              break;
            }
          }
        }
      }
    }
    setConfirmExitValue(dispatch, true);
    setisFieldChanged(true);
    setDefaultValues({ ...defaultValues, ...data });
  };

  const updateFormConfig = (data: any) => {
    formJsonData?.sections.map((section: any) => {
      section?.rows.map((row: any) => {
        row?.fields.map((field: any) => {
          if (data.errors && field.key && data.records && data.records[field.key]) {
            field.helperText = data.records[field.key]?.message;
            field.error = true;
          } else {
            field.helperText = '';
            field.error = false;
          }
        });
      });
    });
  };
  const checkType = (obj: any) => {
    for (const keys of Object.keys(obj)) {
      if (obj?.[keys]?.type === 'required') {
        return true;
      }
    }
    return false;
  };
  const onFormSubmit = async (data: any) => {
    if (!isFieldChanged) {
      dispatch(
        setMessage({
          msgDetails: 'No data modified',
          severity: 'info'
        })
      );
      return;
    }
    updateFormConfig(data);
    let validation = false;
    if (Object.keys(rules).length > 0) {
      Object.keys(rules).map((key: any) => {
        if (rules[key]?.required?.value) {
          if (changedData[key] == null || changedData[key] == '') {
            validation = true;
          }
        }
      });
    }
    if (data.success && !validation) {
      delete changedData?.type;
      const dataObj: any = JSON.parse(JSON.stringify(changedData));

      /**section docs maping submitted files start */
      const sectionAttachements = dataObj?.section_attchements;
      const prevFilesData = dataObj?.file_data;
      const removedFiles: any = dataObj?.removedFiles ? dataObj?.removedFiles : [];
      delete dataObj?.section_attchements;
      delete dataObj?.file_data;
      delete dataObj?.removedFiles;
      delete dataObj?.event_uuid;

      const fileData: any = [];
      if (prevFilesData) {
        prevFilesData.map((file: any) => {
          if (!removedFiles.includes(file.file_master_id)) {
            fileData.push({
              file_id: file.file_master_id,
              ctms_raw_file_name: file.ctms_raw_file_name,
              section_name: file.section_name,
              section_number: file.section_number
            });
          }
        });
      }
      if (sectionAttachements) {
        sectionAttachements.map((section: any) => {
          if (section?.submitedFiles) {
            section?.submitedFiles.map((file: any) => {
              if (!removedFiles.includes(file.id)) {
                fileData.push({
                  file_id: file.id,
                  ctms_raw_file_name: file.ctms_raw_file_name,
                  section_name: section.sectionData.section_name,
                  section_number: section.sectionData.sectionId
                });
              }
            });
          }
        });
      }
      /**section docs maping submitted files end */

      if (Object.keys(dataObj).length > 0) {
        Object.keys(dataObj).map((dataKey: any) => {
          if (dataObj[dataKey] == null) {
            delete dataObj[dataKey];
          }
          if (Array.isArray(dataObj[dataKey])) {
            dataObj[dataKey] = { key: dataObj[dataKey] };
          }
        });
      }

      delete dataObj?.file_data;
      const reqPayload = {
        OID: selectedformData.form_oid,
        feasibility_form_version: selectedformData.feasibility_form_version,
        data_json: dataObj,
        file_data: fileData
      };
      if (isUpdate && currentDataEntryFormId != null) {
        updateFeasibilityFormDataFunc({
          data: { ...reqPayload, id: currentDataEntryFormId, updated_by: user },
          study_id: selectedStudy,
          site_id: selectedSite,
          country: selectedCountry,
          application_module_section: 'STARTUP'
        });
      } else {
        createFeasibilityFromDataFunc({
          data: { ...reqPayload, created_by: user },
          study_id: selectedStudy,
          site_id: selectedSite,
          country: selectedCountry,
          application_module_section: 'STARTUP'
        });
      }
    } else if (data.errors && checkType(data.records)) {
      dispatch(
        setMessage({
          msgDetails: 'Missing mandatory data',
          severity: 'error'
        })
      );
    } else if (data.errors) {
      dispatch(
        setMessage({
          msgDetails: 'Invalid Data',
          severity: 'error'
        })
      );
    }

    setisFieldChanged(false);
  };

  const handleSave = () => {
    formRef.current.submit(onFormSubmit);
    setConfirmExitValue(dispatch, false);
  };

  return (
    <>
      <Grid container spacing={1} sx={{ mb: 1.5, alignItems: 'center', mt: -2 }}>
        <Grid item xs>
          <Button
            onClick={handelBackButton}
            key={staticData.FeasibilityTable.back_button}
            startIcon={<DynamicIcon name={staticData.FeasibilityTable.icon} />}
            sx={{ marginLeft: '8px' }}
          >
            {staticData.FeasibilityTable.back_button_name}
          </Button>
        </Grid>
        <Grid item xs>
          <Button
            sx={{ alignSelf: 'center', float: 'right', display: FeasibilityPermission ? 'block' : 'none' }}
            onClick={handleSave}
            variant="contained"
          >
            Save
          </Button>
        </Grid>
      </Grid>
      <Typography variant="h3" ml={2} mb={1.5}>
        {selectedformData.name}
      </Typography>
      <Grid>
        {formJsonData != null ? (
          defaultValues && rules ? (
            <DJ2Form
              updateFormConfig={updateFormConfig}
              key={tempField}
              ref={formRef}
              initialValues={defaultValues}
              rules={rules}
              formConfig={formJsonData}
              onChange={onDJ2Change}
              SetchangedData={SetchangedData}
              isReadOnly={!FeasibilityPermission}
            />
          ) : null
        ) : null}
      </Grid>
      <PopupComponent
        open={openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
            }}
            className="grey-btn"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
              dispatch(setShowCMPArr('feasibilityTable'));
              setConfirmExitPopupVal(dispatch, false);
              setisFieldChanged(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
    </>
  );
};
export default FeasibilityForm;
